import { render, staticRenderFns } from "./PrintProviders.vue?vue&type=template&id=af166b3c&"
import script from "./PrintProviders.js?vue&type=script&lang=js&"
export * from "./PrintProviders.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports